module.exports = __webpack_public_path__ + "static/c2-432b9b80ee3605a9805927bb9ca32eac.png";